import CommentOutlinedIcon from '@mui/icons-material/CommentOutlined'
import { IconButton, Popover, Stack, Typography } from '@mui/material'
import { MouseEvent, useState } from 'react'

export function SharedCommentControl({
  comment,
  sharedBy,
  sharedAt,
}: {
  comment: string
  sharedBy?: string
  sharedAt?: string | null
}) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

  const handlePopoverOpen = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation()
    setAnchorEl(event.currentTarget)
  }

  const handlePopoverClose = () => {
    setAnchorEl(null)
  }

  const open = Boolean(anchorEl)

  const formatPopoverContent = () => {
    return (
      <Stack spacing={1} sx={{ p: 1 }}>
        {!!comment && <Typography variant="body2">{comment}</Typography>}
        {sharedBy && sharedAt && (
          <>
            <Typography variant="caption" color="text.secondary">
              Shared by: {sharedBy}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Date: {new Date(sharedAt).toLocaleDateString()}
            </Typography>
          </>
        )}
      </Stack>
    )
  }

  return (
    <>
      <IconButton
        sx={{ padding: 0 }}
        disableRipple
        onMouseEnter={handlePopoverOpen}
        onMouseLeave={handlePopoverClose}
        onClick={handlePopoverOpen}
      >
        <CommentOutlinedIcon />
      </IconButton>
      <Popover
        id="mouse-over-popover"
        sx={{ pointerEvents: 'none' }}
        open={open}
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        onClose={handlePopoverClose}
        disableRestoreFocus
      >
        {formatPopoverContent()}
      </Popover>
    </>
  )
}
